import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "card-container pageheader stores" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "header" }, "Stores")
], -1)
const _hoisted_4 = { class: "search toprow" }
const _hoisted_5 = { class: "p-input-icon-left field-container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_7 = { class: "bottom" }
const _hoisted_8 = { class: "search bottomrow" }
const _hoisted_9 = { class: "p-input-icon-left field-container" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_11 = { class: "container flex-grow-1 maintable stores" }
const _hoisted_12 = { class: "button-container" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "storename" }, "Store Name", -1)
const _hoisted_15 = {
  key: 0,
  class: "error"
}
const _hoisted_16 = { class: "field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "locationname" }, "Location Name", -1)
const _hoisted_18 = {
  key: 0,
  class: "error"
}
const _hoisted_19 = { class: "field" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "connectionid" }, "Connection ID", -1)
const _hoisted_21 = {
  key: 0,
  class: "error"
}
const _hoisted_22 = { class: "field" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "apikey" }, "API Key", -1)
const _hoisted_24 = {
  key: 0,
  class: "error"
}
const _hoisted_25 = { class: "field" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "authenticationstring" }, "Authentication String", -1)
const _hoisted_27 = {
  key: 0,
  class: "error"
}
const _hoisted_28 = { class: "field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "id" }, "Location ID", -1)
const _hoisted_30 = { class: "storeid" }
const _hoisted_31 = {
  key: 0,
  class: "error"
}
const _hoisted_32 = { class: "field" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "features" }, "Features", -1)
const _hoisted_34 = ["for"]
const _hoisted_35 = { class: "field" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "Status", -1)
const _hoisted_37 = { class: "formgrid grid" }
const _hoisted_38 = { class: "field-radiobutton col-12" }
const _hoisted_39 = { for: "status" }
const _hoisted_40 = { class: "data" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("strong", null, "Store Name:", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = { class: "data" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("strong", null, "Location Name:", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = { class: "data" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("strong", null, "Location ID:", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = { class: "data" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("strong", null, "Connection ID:", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = { class: "data" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("strong", null, "API Key:", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = { class: "data" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("strong", null, "Authentication String:", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_58 = { class: "data" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("strong", null, "Features:", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = {
  class: "features",
  style: {"list-style-type":"none","padding-left":"0","margin-top":"0"}
}
const _hoisted_62 = { class: "data" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("strong", null, "Status:", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_65 = {
  key: 0,
  class: "p-button-rounded btn-blocked"
}
const _hoisted_66 = {
  key: 1,
  label: "Disabled",
  class: "p-button-rounded btn-blocked"
}
const _hoisted_67 = {
  key: 0,
  class: "data"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("strong", null, "Emails:", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_70 = { style: {"list-style-type":"none","padding-left":"0","margin-top":"0"} }

import { ref, onBeforeMount, computed } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import { useToast } from 'primevue/usetoast';
import { useAuth0 } from "@auth0/auth0-vue";
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import { useRouter } from 'vue-router';
import { HmacSHA1, enc } from 'crypto-js';
import ErrorModal from './ErrorModal.vue';
import { openErrorModal } from '@/composables/useErrorLog';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'Stores',
  setup(__props) {

const auth0 = useAuth0();
const storeid = ref('');
const role = ref('');
const roles = ref([]);
const storestatus = ref('');
const selectedFeatures = ref([]);
const selectedfeatureids = ref([]);
const features = ref([]);
const router = useRouter();
const users = ref();
const loadingDT = ref(false);

onBeforeMount(async () => {
	loadingDT.value = true;
	const store = useStore();
	const auth0 = useAuth0();
	const accessToken = await auth0.getAccessTokenSilently();
	storeid.value = store.state.storeid;
	role.value = store.state.role;
	storestatus.value = store.state.storestatus;

	if (storestatus.value == 'Disable' || role.value != 'SupportAdmin') {
		router.push('/storedisable');
	}

	if (role.value === 'SupportAdmin') {
		await getAllFeatures(accessToken);
		await getUserDetails(accessToken);
		await getAllUserRoles(accessToken);
		await getAllStores(accessToken);
		loadingDT.value = false;
	}
});

const toast = useToast();
const dt = ref();
const stores = ref();
const updateStoreDialog = ref(false);
const viewstoreDialog = ref(false);
const store = ref({ id: '', storename: '', locationname: '', connectionid: '', apikey: '', authenticationstring: '', storestatus: '', validate: '', managedfeatureids: '', storestatusbool: false, emails: [] });
const filters = ref({
	'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
});
const submitted = ref(false);
const createORedit = ref('');
const checkStoreValidityLoader = ref(false);
const validationIndex = ref();
const currentPage = ref(0);
const rowsPerPage = ref(10);

/**
 * Clear filter by initializing
 */
function clearFilter() {
	initFilters();
}

/**
 * Initialize filter
 */
function initFilters() {
	filters.value = {
		'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
	};
}

/**
 * Validation of uuid
 * @param value 
 */
function valid1(value: string) {
	const uuid = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi.test(value);
	return uuid;
}

/**
 * Location ID should be the same with UUID removed hypens
 * @param value 
 */
function valid2(value: string) {
	const search = '-';
	const searchRegExp = new RegExp(search, 'g');
	const replaceWith = '';

	if ((value.length == 32) && (store.value.id.replace(searchRegExp, replaceWith) == value))
		return true;
	else
		return false;
}

/**
 * Preparation of rules
 */
const rules = computed(() => ({
	id: { required: helpers.withMessage('Location ID cannot be empty, click the Generate button.', required), valid: helpers.withMessage('Location ID format must be 12345678-xxxx-xxxx-xxxx-1234567890ab', valid1) },
	connectionid: { required: helpers.withMessage('Connection ID cannot be empty.', required), valid: helpers.withMessage('Connection ID must be 32 characters and same as storeid without hyphen -', valid2) },
	apikey: { required: helpers.withMessage('API ID cannot be empty.', required) },
	authenticationstring: { required: helpers.withMessage('Authentication String cannot be empty.', required) },
	storename: { required: helpers.withMessage('Store Name cannot be empty.', required) },
	locationname: { required: helpers.withMessage('Location Name cannot be empty.', required) },
}));

/**
 * Vuelidate initialization
 */
let v$ = useVuelidate(rules, store);

/**
 * Hide create store dialog
 */
function hideDialog() {
	v$.value.$reset();
	updateStoreDialog.value = false;
	store.value = { id: '', storename: '', locationname: '', connectionid: '', apikey: '', authenticationstring: '', storestatus: '', validate: '', managedfeatureids: '', storestatusbool: false, emails: [] };
	submitted.value = false;
	selectedFeatures.value = [];
	selectedfeatureids.value = [];
}

/**
 * Hide view dialog
 */
function hideViewDialog() {
	viewstoreDialog.value = false;
}

/**
 * Update store
 */
const updateStore = async () => {
	submitted.value = true;

	store.value.validate = validateCreds(store.value.connectionid, store.value.apikey, store.value.authenticationstring);
	store.value.managedfeatureids = selectedFeatures.value.filter((item) => item.manageable === true).map((item) => item.featureid).join(',');
	const indexToUpdate = stores.value.findIndex((item) => item.id === store.value.id);
	store.value.storestatus = store.value.storestatusbool ? 'Enable' : 'Disable'
	stores.value[indexToUpdate] = store.value;

	let storedata = {
		id: store.value.id,
		storename: store.value.storename,
		locationname: store.value.locationname,
		connectionid: store.value.connectionid,
		apikey: store.value.apikey,
		authenticationstring: store.value.authenticationstring,
		managedfeatureids: store.value.managedfeatureids,
		storestatus: store.value.storestatusbool ? 'Enable' : 'Disable'
	};
	const accessToken = await auth0.getAccessTokenSilently();
	const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/store/" + store.value.id;

	try {
		const response = await fetch(url, {
			method: 'PATCH',
			body: JSON.stringify(storedata),
			headers: {
				Authorization: `Bearer ${accessToken}`,
				'Content-Type': 'application/json'
			},
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		if (response.status == 200) {
			toast.add({ severity: 'success', summary: 'Successful', detail: 'Store has been updated.', life: 3000 });
		}
		else
			toast.add({ severity: 'error', summary: 'Error', detail: 'Store edit error.', life: 3000 });
	} catch (e) {
		openErrorModal(e.message);
		toast.add({ severity: 'error', summary: 'Error', detail: 'Store edit error.', life: 3000 });
	}
	updateStoreDialog.value = false;
	store.value = { id: '', storename: '', locationname: '', connectionid: '', apikey: '', authenticationstring: '', storestatus: '', validate: '', managedfeatureids: '', storestatusbool: false, emails: [] };
	viewstoreDialog.value = false;
}

/**
 * Prepare data for editing
 * @param prod 
 */
function editstore(prod) {
	store.value = { ...prod };
	updateStoreDialog.value = true;
	createORedit.value = "Edit Store";
	selectedFeatures.value = [];
	selectedfeatureids.value = [];
}

/**
 * Prepare data for viewing
 * @param prod 
 */
function viewstore(prod) {
	store.value = { ...prod };
	viewstoreDialog.value = true;
}

/**
 * Immediately sends request to block and unblock user
 * @param prod 
 */
async function blockunblockstore(prod) {
	store.value = { ...prod };
	let blockunblock = "";
	let blockunblockLabel = "";

	if (store.value.storestatus == "Enable") {
		stores.value[findIndexById(store.value.id)].storestatus = "Disable";
		stores.value[findIndexById(store.value.id)].storestatusbool = false;
		blockunblock = "Disable";
		blockunblockLabel = "store is disabled";
	} else {
		stores.value[findIndexById(store.value.id)].storestatus = "Enable";
		stores.value[findIndexById(store.value.id)].storestatusbool = true;
		blockunblock = "Enable";
		blockunblockLabel = "store is enabled";
	}

	let storedata = {
		id: store.value.id,
		storestatus: blockunblock
	};
	const accessToken = await auth0.getAccessTokenSilently();
	const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/store/" + store.value.id;

	try {
		const response = await fetch(url, {
			method: 'PATCH',
			body: JSON.stringify(storedata),
			headers: {
				Authorization: `Bearer ${accessToken}`,
				'Content-Type': 'application/json'
			},
		});
		if (response.status >= 200 && response.status < 300) {
			toast.add({ severity: 'success', summary: 'Successful', detail: blockunblockLabel, life: 3000 });
		}
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
	} catch (e) {
		openErrorModal(e.message);
	}
}

/**
 * Find index by id
 * @param id 
 */
function findIndexById(id: string) {
	let index = -1;
	for (let i = 0; i < stores.value.length; i++) {
		if (stores.value[i].id === id) {
			index = i;
			break;
		}
	}

	return index;
}

/**
 * Validation of connection id, api key, and authentication string
 * @param connectionid 
 * @param apikey 
 * @param authenticationstring 
 */
function validateCreds(connectionid: string, apikey: string, authenticationstring: string) {
	if (enc.Base64.stringify((HmacSHA1(connectionid, apikey))) === authenticationstring)
		return "Valid";
	else
		return "Invalid";
}

/**
 * Get all features
 * @param accessToken 
 */
const getAllFeatures = async (accessToken: string) => {
	const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/features";
	try {
		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${accessToken}`,
				'Content-Type': 'application/json'
			},
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		features.value = data.message;
	} catch (e) {
		openErrorModal(e.message);
	}
}

/**
 * Get all users using store id
 * @param accessToken 
 */
 const getUserDetails = async (accessToken: string) => {
	const Userurl = process.env.VUE_APP_NODEJS_BASE_URL + "sa/" + storeid.value; //to get storeadmin users
	try {
		const response = await fetch(Userurl, {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			}
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		users.value = data.message;
	} catch (e) {
		openErrorModal(e.message);
	}
}

/**
 * Get all user roles
 * @param accessToken 
 */
const getAllUserRoles = async (accessToken: string) => {
	const url = process.env.VUE_APP_NODEJS_BASE_URL + "sa/userroles";
	try {
		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${accessToken}`,
				'Content-Type': 'application/json'
			},
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		roles.value = parseRoleData(data.message);
	} catch (e) {
		openErrorModal(e.message);
	}
}

/**
 * Get all stores
 * @param accessToken 
 */
const getAllStores = async (accessToken: string) => {
	const storeurl = process.env.VUE_APP_NODEJS_BASE_URL + "sa/store/all";

	try {
		const response = await fetch(storeurl, {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			}
		});
		const data = await response.json();
		if (response.status > 400) {
			throw new Error(JSON.stringify(data.error));
		}
		stores.value = data.message;
		stores.value.map(async (item) => {
			item.pinged = false;
			item.pinging = false;
			item.connected = false;
			item.validate = validateCreds(item.connectionid, item.apikey, item.authenticationstring);
			item.storestatusbool = item.storestatus === 'Enable';
			item.emails = users.value.filter((userItems) => userItems.storeid === item.id).map((userItems) => userItems.email);
		});
	} catch (e) {
		openErrorModal(e.message);
	}
}

/**
 * Parse fetched roles
 * @param data 
 */
const parseRoleData = (data) => {
	return data.map((item) => ({
		label: item.userrole,
		value: item.userrole,
		availablefeatureids: item.availablefeatureids,
		manageable: item.manageable
	}));
}

/**
 * Create and edit store should parse the selected features
 * This will set the default feature to be selected initially on create and update form
 * @param featureItems 
 * @param managedfeatureids 
 */
const setSelectedFeatures = (featureItems, managedfeatureids) => {
	if (managedfeatureids === null) {
		featureItems.forEach((feature) => {
			if (!feature.manageable && !selectedfeatureids.value.includes(feature.featureid)) {
				selectedfeatureids.value.push(feature.featureid);
				selectedFeatures.value.push(feature);
			}
		});
		return featureItems
	}

	featureItems.forEach((feature) => {
		if ((managedfeatureids.includes(feature.featureid) && !selectedfeatureids.value.includes(feature.featureid)) ||
			!feature.manageable && !selectedfeatureids.value.includes(feature.featureid)) {
			selectedfeatureids.value.push(feature.featureid);
			selectedFeatures.value.push(feature);
		}
	});
	return featureItems;
}

/**
 * Set managed feature ids
 * @param managedfeatureids 
 */
const setManagedFeatureIds = (managedfeatureids) => {
	// if the Store detail has no managedfeatureids then select all non-manageable feature in features table
	if (managedfeatureids === null) {
		// get all non-manageable features, it is accessible by default
		return features.value.filter((feature) => feature.manageable === false);
	}

	// if the store has managedfeatureids, then select only saved managedfeatureids and all non-manageable feature in features table
	const managedFeatureIds = managedfeatureids.split(',').map(Number);
	return features.value.filter((feature) => managedFeatureIds.includes(feature.featureid) || feature.manageable === false);
}

/**
 * Set view validity dialog to true
 * @param data 
 * @param index 
 */
const setStoreDetails = (data, index) => {
	if (checkStoreValidityLoader.value === false) {
		store.value = { ...data };
		validationIndex.value = index;
		const storeItemIndex = validationIndex.value + (currentPage.value * rowsPerPage.value);
		stores.value[storeItemIndex].pinging = true;
		checkStoreValidity();
	}
}

/**
 * Send request to apiserver to actually ping 2 major APIs used in DVI and VIN Scanner
 */
const checkStoreValidity = async () => {
	checkStoreValidityLoader.value = true;
	const accessToken = await auth0.getAccessTokenSilently();
	const url = process.env.VUE_APP_NODEJS_BASE_URL + `sa/store/validity/${store.value.id}`;
	const validation = validateCreds(store.value.connectionid, store.value.apikey, store.value.authenticationstring);
	const storeItemIndex = validationIndex.value + (currentPage.value * rowsPerPage.value);

	try {
		const response = await fetch(url, {
			headers: {
				Authorization: `Bearer ${accessToken}`
			},
		});
		const result = await response.json();
		checkStoreValidityLoader.value = false;
		stores.value[storeItemIndex].pinged = true;
		if (response.status > 400) {
			throw new Error(JSON.stringify(result.error));
		}
		if (validation === 'Valid' && result.message === 'Valid') {
			stores.value[storeItemIndex].connected = true;
			return toast.add({ severity: 'success', summary: `Store is Connected`, detail: 'The store has successfully established a connection.', life: 10000 });
		}
	} catch (e) {
		openErrorModal(e.message);
		stores.value[storeItemIndex].pinging = false;
		stores.value[storeItemIndex].connected = false;
		toast.add({ severity: 'error', summary: `Store is not Connected`, detail: 'Unable to establish a connection for the store.', life: 10000 });
	}
}

/**
 * Set current page and rows per page value on page change
 * @param event 
 */
const handlePageChange = (event) => {
	currentPage.value = event.page;
	rowsPerPage.value = event.rows;
}

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorModal),
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_InputText, {
              modelValue: filters.value['global'].value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value['global'].value) = $event)),
              placeholder: "Search"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-text clear",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (clearFilter()))
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_InputText, {
              modelValue: filters.value['global'].value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value['global'].value) = $event)),
              placeholder: "Search"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-text clear",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (clearFilter()))
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_DataTable, {
        class: "managerclient-data-table",
        onPage: handlePageChange,
        ref_key: "dt",
        ref: dt,
        loading: loadingDT.value,
        value: stores.value,
        dataKey: "id",
        paginator: true,
        rows: 10,
        filters: filters.value,
        stripedRows: "",
        responsiveLayout: "stack",
        breakpoint: "800px",
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
        rowsPerPageOptions: [5, 10, 25],
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} stores"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "storename",
            header: "Store Name",
            sortable: true,
            class: "storename"
          }),
          _createVNode(_component_Column, {
            field: "locationname",
            header: "Location Name",
            sortable: true,
            class: "locationname"
          }),
          _createVNode(_component_Column, {
            field: "id",
            header: "Store ID",
            sortable: true,
            class: "storeid"
          }),
          _createVNode(_component_Column, {
            field: "storestatus",
            class: "status",
            header: "Status",
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.storestatus == 'Enable')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    label: "Enabled",
                    class: _normalizeClass(["p-button-rounded p-button-success btn-blocked", slotProps.data.storestatus]),
                    onClick: ($event: any) => (blockunblockstore(slotProps.data))
                  }, null, 8, ["class", "onClick"]))
                : (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    label: "Disabled",
                    class: _normalizeClass(["p-button-rounded p-button-danger btn-blocked", slotProps.data.storestatus]),
                    onClick: ($event: any) => (blockunblockstore(slotProps.data))
                  }, null, 8, ["class", "onClick"]))
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "view",
            header: " ",
            sortable: false,
            class: "view"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Button, {
                  label: "View",
                  class: "p-button-rounded btn-view btn-secondary",
                  onClick: ($event: any) => (viewstore(slotProps.data))
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  label: "Edit",
                  class: "p-button-rounded btn-edit btn-secondary",
                  onClick: ($event: any) => (editstore(slotProps.data))
                }, null, 8, ["onClick"]),
                (!slotProps.data.pinged)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!slotProps.data.pinging)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            label: "Test Connection",
                            class: "p-button-rounded btn-primary btn-connection sml",
                            onClick: ($event: any) => (setStoreDetails(slotProps.data, slotProps.index))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (slotProps.data.pinging)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            label: "Testing",
                            class: "p-button-rounded btn-primary btn-connection sml",
                            loading: checkStoreValidityLoader.value
                          }, null, 8, ["loading"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (slotProps.data.connected)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            label: "Connected",
                            class: "p-button-rounded p-button-success btn-primary btn-connection sml"
                          }))
                        : _createCommentVNode("", true),
                      (!slotProps.data.connected)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            label: "Not Connected",
                            class: "p-button-rounded p-button-danger btn-connection sml"
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "value", "filters"]),
      _createVNode(_component_Dialog, {
        visible: updateStoreDialog.value,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((updateStoreDialog).value = $event)),
        header: "Edit Store",
        modal: true,
        class: "p-fluid"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Cancel",
            class: "p-button-rounded btn-cancel btn-secondary",
            onClick: hideDialog
          }),
          _createVNode(_component_Button, {
            label: "Save",
            class: "p-button-rounded btn-save btn-primary",
            onClick: updateStore
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_InputText, {
              id: "storename",
              modelValue: store.value.storename,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((store.value.storename) = $event)),
              modelModifiers: { trim: true },
              disabled: "true",
              class: _normalizeClass({ 'p-invalid': submitted.value && !store.value.storename })
            }, null, 8, ["modelValue", "class"]),
            (_unref(v$).storename.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(v$).storename.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_InputText, {
              id: "locationname",
              modelValue: store.value.locationname,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((store.value.locationname) = $event)),
              modelModifiers: { trim: true },
              disabled: "true",
              class: _normalizeClass({ 'p-invalid': submitted.value && !store.value.locationname })
            }, null, 8, ["modelValue", "class"]),
            (_unref(v$).locationname.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(v$).locationname.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_InputText, {
              id: "connectionid",
              modelValue: store.value.connectionid,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((store.value.connectionid) = $event)),
              modelModifiers: { trim: true },
              disabled: "true",
              class: _normalizeClass({ 'p-invalid': submitted.value && !store.value.connectionid })
            }, null, 8, ["modelValue", "class"]),
            (_unref(v$).connectionid.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(v$).connectionid.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_component_InputText, {
              id: "apikey",
              modelValue: store.value.apikey,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((store.value.apikey) = $event)),
              modelModifiers: { trim: true },
              disabled: "true",
              class: _normalizeClass({ 'p-invalid': submitted.value && !store.value.apikey })
            }, null, 8, ["modelValue", "class"]),
            (_unref(v$).apikey.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(v$).apikey.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_InputText, {
              id: "authenticationstring",
              modelValue: store.value.authenticationstring,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((store.value.authenticationstring) = $event)),
              modelModifiers: { trim: true },
              disabled: "true",
              class: _normalizeClass({ 'p-invalid': submitted.value && !store.value.authenticationstring })
            }, null, 8, ["modelValue", "class"]),
            (_unref(v$).authenticationstring.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(v$).authenticationstring.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_InputText, {
                id: "id",
                modelValue: store.value.id,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((store.value.id) = $event)),
                modelModifiers: { trim: true },
                disabled: "true"
              }, null, 8, ["modelValue"]),
              (_unref(v$).id.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_unref(v$).id.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(setSelectedFeatures(features.value, store.value.managedfeatureids), (feature, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "field-checkbox"
              }, [
                _createVNode(_component_Checkbox, {
                  id: index,
                  name: "feature",
                  value: feature,
                  modelValue: selectedFeatures.value,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedFeatures).value = $event)),
                  disabled: !feature.manageable
                }, null, 8, ["id", "value", "modelValue", "disabled"]),
                _createElementVNode("label", {
                  for: feature.featurename
                }, _toDisplayString(feature.featurename), 9, _hoisted_34)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_InputSwitch, {
                  modelValue: store.value.storestatusbool,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((store.value.storestatusbool) = $event)),
                  style: {"border-radius":"1.5em"}
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_39, _toDisplayString(store.value.storestatusbool ? 'Enabled' : 'Disabled'), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: viewstoreDialog.value,
        "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((viewstoreDialog).value = $event)),
        header: "View Store Details",
        modal: true,
        class: "p-fluid"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Cancel",
            class: "p-button-rounded btn-cancel btn-secondary",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (hideViewDialog()))
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("p", null, [
              _hoisted_41,
              _hoisted_42,
              _createElementVNode("span", null, _toDisplayString(store.value.storename), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("p", null, [
              _hoisted_44,
              _hoisted_45,
              _createElementVNode("span", null, _toDisplayString(store.value.locationname), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("p", null, [
              _hoisted_47,
              _hoisted_48,
              _createElementVNode("span", null, _toDisplayString(store.value.id), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("p", null, [
              _hoisted_50,
              _hoisted_51,
              _createElementVNode("span", null, _toDisplayString(store.value.connectionid), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("p", null, [
              _hoisted_53,
              _hoisted_54,
              _createElementVNode("span", null, _toDisplayString(store.value.apikey), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("p", null, [
              _hoisted_56,
              _hoisted_57,
              _createElementVNode("span", null, _toDisplayString(store.value.authenticationstring), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("p", null, [
              _hoisted_59,
              _hoisted_60,
              _createElementVNode("ul", _hoisted_61, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(setManagedFeatureIds(store.value.managedfeatureids), (feature, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("span", null, _toDisplayString(feature.featurename), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("p", null, [
              _hoisted_63,
              _hoisted_64,
              (store.value.storestatus == 'Enable')
                ? (_openBlock(), _createElementBlock("span", _hoisted_65, "Enabled"))
                : (_openBlock(), _createElementBlock("span", _hoisted_66, "Disabled"))
            ])
          ]),
          (store.value.emails.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                _createElementVNode("p", null, [
                  _hoisted_68,
                  _hoisted_69,
                  _createElementVNode("ul", _hoisted_70, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(store.value.emails, (email, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, [
                        _createElementVNode("span", null, _toDisplayString(email), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}
}

})